export { default as FullpageSpinner } from './fullpage-spinner';
